import RefreshIcon from '@/common/assets/icons/refreshIcon.svg?react';
import { Center } from 'styled-system/jsx';
import Typography from '@/common/components/base/typography/Typography.tsx';
import { UseSignatureReturn } from '@/common/hooks/useSignature.ts';

const RefreshSign = ({ clearPad }: UseSignatureReturn) => {
  return (
    <Center
      onClick={clearPad}
      borderBottomRadius="8px"
      bgColor={'purple-6'}
      h="40px"
      width="100%"
      cursor="pointer"
    >
      <Typography textStyle="b2" display="flex" gap="8px" alignItems="center">
        <RefreshIcon width={20} height={20} />
        ترسیم مجدد امضا
      </Typography>
    </Center>
  );
};

export default RefreshSign;
